import { render, staticRenderFns } from "./thPrivacy.vue?vue&type=template&id=0a0653da&scoped=true&"
import script from "./thPrivacy.vue?vue&type=script&lang=js&"
export * from "./thPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./thPrivacy.vue?vue&type=style&index=0&id=0a0653da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0653da",
  null
  
)

export default component.exports